var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgQuestion = function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 19.167A9.167 9.167 0 1 0 10 .833a9.167 9.167 0 0 0 0 18.334ZM10.162 5c-.88 0-1.644.392-2.179.921-.524.52-.9 1.243-.9 1.996a.833.833 0 0 0 1.667 0c0-.21.12-.529.406-.81.274-.273.633-.44 1.006-.44.9 0 1.609.566 1.609 1.51 0 .345-.093.542-.21.694-.139.181-.34.334-.652.55l-.093.064c-.567.388-1.487 1.017-1.487 2.363v.231a.833.833 0 0 0 1.667 0v-.23c0-.434.194-.595.861-1.057.299-.207.708-.492 1.026-.906.342-.445.554-1 .554-1.709C13.437 6.114 11.77 5 10.162 5Zm.834 9.104a.833.833 0 0 0-1.667 0v.063a.833.833 0 0 0 1.667 0v-.063Z",
    fill: "#7A8B9E"
  })));
};

export default SvgQuestion;